<template>
  <div id="side-panel" :class="{ expand: !isLoggedIn }">
    <logo v-if="!isLoggedIn" />

    <div class="logo-wrapper" v-if="isLoggedIn">
      <logo />
      <logo-text />
    </div>

    <nav-menu v-if="isLoggedIn" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Logo from '@/components/Logo';
import LogoText from '@/components/LogoText';

import NavMenu from './NavMenu';

export default {
  name: 'SidePanel',
  components: {
    Logo,
    LogoText,
    NavMenu
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn'
    })
  }
};
</script>

<style lang="scss">
@import '~@/assets/scss/colors';
@import '~@/assets/scss/dimens';

#side-panel {
  width: $sidePanelWidth;
  height: 100%;
  background-color: $geranium;
  color: $babyPowder;
  position: fixed;
  top: 0;
  left: 0;
  padding: 15px;
  z-index: 99;
  overflow-y: auto;

  .logo-wrapper {
    margin-bottom: 50px;

    .logo {
      width: 50px;
      margin-right: 12px;
      display: inline-block;
      vertical-align: middle;
    }

    .logo-text {
      font-size: 20px;
      color: $babyPowder;
      display: inline-block;
      vertical-align: middle;
    }
  }

  #nav-menu {
    margin-left: -15px;
    margin-right: -15px;
    width: calc(100% + 30px);
  }

  &.expand {
    display: flex;

    .logo {
      width: 160px;
      display: block;
      margin: auto;
      align-self: center;
    }
  }

  @media (max-width: 991px) {
    width: $sidePanelWidthTablet;

    &.expand {
      .logo {
        width: 150px;
      }
    }
  }

  @media (max-width: 767px) {
    display: none;
  }
}
</style>
